export default __webpack_public_path__ + "static/media/p1-c2-ti.9d68e8f3.png";